import React, { useEffect } from 'react'
import { DiJavascript } from 'react-icons/di'
import { SiCss3, SiTailwindcss, SiHtml5, SiExpress, SiMongodb } from 'react-icons/si'
import { GiFlowerEmblem } from 'react-icons/gi'
import { GrReactjs } from 'react-icons/gr'
function Skills() {
    return (
        <div className='my-[100px]'>
            <h2 className="text-3xl text-white mb-[70px] text-center uppercase text-[#ffff00] font-bold flex justify-center items-center">Skills <img src="https://flevix.com/wp-content/uploads/2020/01/Lazy-Loader.svg" className='w-[70px] h-[70px] ml-[5px]'/></h2>
            <div className=" grid justify-items-center grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-[45px]">

                <div className="tooltip cursor-pointer" data-tip="HTML5">
                    <div className="radial-progress bg-red-700 text-primary-content border-4 border-red-700 text-5xl" style={{ '--value': '95', '--size': '10rem' }}> <SiHtml5 /></div>
                </div>

                <div className="tooltip cursor-pointer" data-tip="CSS3">
                    <div className="radial-progress bg-indigo-700 text-primary-content border-4 border-indigo-700 text-5xl" style={{ '--value': '85', '--size': '10rem' }}><SiCss3 /></div>
                </div>

                <div className="tooltip cursor-pointer" data-tip="JavaScript">
                    <div className="radial-progress bg-amber-500 text-primary-content border-4 border-amber-500 text-5xl" style={{ '--value': '90', '--size': '10rem' }}><DiJavascript /></div>
                </div>

                <div className="tooltip cursor-pointer" data-tip="DaisyUI">
                    <div className="radial-progress bg-fuchsia-500 text-primary-content border-4 border-fuchsia-500 text-5xl" style={{ '--value': '90', '--size': '10rem' }}><GiFlowerEmblem /> </div>
                </div>

                <div className="tooltip cursor-pointer" data-tip="TailwindCSS">
                    <div className="radial-progress bg-blue-800 text-primary-content border-4 border-blue-800 text-5xl" style={{ '--value': '80', '--size': '10rem' }}> <SiTailwindcss /></div>
                </div>

                <div className="tooltip cursor-pointer" data-tip="React Js">
                    <div className="radial-progress bg-primary text-primary-content border-4 border-primary text-5xl" style={{ '--value': '80', '--size': '10rem' }}><GrReactjs /></div>
                </div>

                <div className="tooltip cursor-pointer" data-tip="Express Js">
                    <div className="radial-progress bg-pink-500 text-primary-content border-4 border-pink-500 text-5xl" style={{ '--value': '70', '--size': '10rem' }}> <SiExpress /></div>
                </div>

                <div className="tooltip cursor-pointer" data-tip="MongoDB">
                    <div className="radial-progress bg-green-800 text-primary-content border-4 border-green-800 text-5xl" style={{ '--value': '75', '--size': '10rem' }}> <SiMongodb /></div>
                </div>

            </div>
        </div>
    )
}

export default Skills